
<div
  class="vue-share-it-button"
  :class="{
    'dark': dark,
    'light': !dark,
    'dense': dense,
    'outline': outline
  }"
>
  <slot></slot>
</div>
